import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ConfirmDeleteUserDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ConfirmDeleteUserDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{top: 122}}>
                    <h2 className="title">Confirm Delete</h2>
                    <p>You are about to delete this user from account<br /> Account Name: <b data-name="userName">{this.props.state.user.selectedAccount.ACCOUNTNUMBER} : {this.props.state.user.selectedAccount.ACCOUNTDESCRIPTION}</b></p>
                    <p>Are you sure you want to proceed?</p>
                    <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
                    <a className="blueButton yesButton" onClick={this.props.deleteUser.bind(this)}>Yes</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

ConfirmDeleteUserDialog = connect(mapStateToProps)(ConfirmDeleteUserDialog);
export default ConfirmDeleteUserDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmDeleteUserDialog.js